import { capitalize } from "common/utils/strings";
import { rtcJobsApi } from "common/state/rtcJobsApi";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ChecklistIcon from "@mui/icons-material/Checklist";
import React, { FC } from "react";

interface SafetyChecklistDisplayProps {
  serial: string;
  fieldId: string;
}

export const SafetyChecklistDisplay: FC<SafetyChecklistDisplayProps> = ({
  serial,
  fieldId,
}) => {
  const { t } = useTranslation();
  const { data, error } = rtcJobsApi.endpoints.getLatestValidChecklist.useQuery(
    {
      robotSerial: serial,
      fieldId,
    },
    { pollingInterval: 30_000, refetchOnMountOrArgChange: 30 }
  );
  let isValid = data?.valid;
  if (error) {
    isValid = false;
  }
  return (
    <div className="flex gap-1">
      <ChecklistIcon fontSize="small" color={isValid ? "success" : "error"} />
      <Typography color={isValid ? "green" : "red"} variant="caption">
        {isValid
          ? capitalize(t("models.autotractor.states.completed"))
          : capitalize(t("models.autotractor.checklists.checklist_one"))}
      </Typography>
    </div>
  );
};
